// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconClockStopwatch = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M51.2471 22.1958L53.52 19.0138C54.2342 18.0139 54.149 16.9839 53.28 16.1151L49.885 12.7199C49.016 11.851 47.9861 11.7657 46.9862 12.48L43.8041 14.7528C41.2708 13.3758 38.3211 12.4902 34.9999 12.1614V8H38.2409C39.4491 8 40.1657 7.15405 39.9671 5.96228L39.6201 3.88007C39.418 2.66797 38.6295 2 37.4007 2H26.5993C25.3704 2 24.5819 2.66797 24.3799 3.88007L24.0328 5.96228C23.8342 7.15405 24.5509 8 25.759 8H28.9999V12.1614C25.6788 12.4902 22.7291 13.3759 20.1958 14.7529L17.0138 12.48C16.0139 11.7657 14.984 11.851 14.1151 12.7199L10.7199 16.115C9.85096 16.9839 9.76576 18.0139 10.48 19.0138L12.7529 22.1958C10.9725 25.4711 10 29.4359 10 34C10 47.5748 18.4251 56 32 56C45.5749 56 54 47.5748 54 34C54 29.4359 53.0275 25.4712 51.2471 22.1958ZM34.023 33.6359C33.9578 34.6644 33.5751 35.3378 32.725 35.9203L23.5784 42.1819C22.7729 42.7339 21.9196 42.5403 21.4313 41.6946L20.052 39.3054C19.5637 38.4597 19.8226 37.6239 20.7034 37.2023L29.9228 32.7834L29.1014 19.595C29.04 18.6296 29.631 18 30.5983 18H33.4017C34.3691 18 34.96 18.6296 34.8987 19.595L34.023 33.6359Z" />
    </svg>
  );
};
